import { Box, Button } from '@mui/material';
import ModalV2 from '/@/components/bayer/modal-v2';
import { _ } from '/@/locale';

const LoteHelpModal = ({ open, onClose, image }: { open: boolean; onClose: () => void; image: string }) => {
    return (
        <ModalV2
            open={open}
            onClose={onClose}
            title={_('El código de lote de la bolsa está en la etiqueta')}
            actions={
                <Button variant='text' onClick={onClose} color='secondary'>
                    {_('Entendido')}
                </Button>
            }
            maxWidth='sm'
        >
            <Box
                component='img'
                src={image}
                alt={_('Bolsa de maíz')}
                sx={{ maxWidth: '100%', height: 'auto', overflow: 'auto' }}
            />
        </ModalV2>
    );
};

export default LoteHelpModal;
